<script lang="ts">
  import { Button } from "@opera-gx/components";
  import { onDestroy, onMount } from "svelte";
  import SvelteMarkdown from "svelte-markdown";
  export let description: string;
  export let url: string | null = null;
  export let label: string | null = null;
  export let defaultLabel: string = "Go to GX.store";
  export let short = false;
  let caret = false;
  let rotate = false;
  let wrapper: HTMLDivElement;
  let timeout: NodeJS.Timeout;
  const calculateCaret = () => {
    caret = wrapper.scrollHeight - wrapper.clientHeight > 0;
  };
  onMount(() => {
    timeout = setTimeout(() => {
      calculateCaret();
    }, 250);

    window.addEventListener("resize", calculateCaret);
  });
  onDestroy(() => {
    clearTimeout(timeout);
    window.removeEventListener("resize", calculateCaret);
  });
  const clickHandler = () => {
    wrapper.scrollTop = rotate ? 0 : wrapper.scrollHeight - 1;

    setTimeout(() => {
      rotate = !rotate;
    }, 100);
  };
  const calculatePosition = () => {
    wrapper.scrollTop + wrapper.clientHeight > wrapper.scrollHeight - 1
      ? (rotate = true)
      : (rotate = false);
  };
</script>

<style lang="scss">
  .description-wrapper {
    display: flex;
    flex-direction: column;
    gap: 5px;
    max-height: 100px;

    @media (width >= 600px), (orientation: landscape) {
      grid-row-start: 3;
      max-height: unset;
    }

    &.short {
      max-height: 70%;
    }
  }

  .description {
    color: hsl(var(--color-N100, var(--color-N77)));
    font-variant-numeric: lining-nums proportional-nums;
    font-feature-settings:
      "clig" off,
      "liga" off;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    overflow-wrap: anywhere;

    :global(img) {
      text-align: center;
      vertical-align: middle;
    }

    :global(p) {
      margin-top: 0;

      :global(img) {
        display: block;
        width: var(--image-width, 75%);
        margin: 0 auto;
      }
    }

    :global(a) {
      color: hsl(var(--color-accent));
      text-decoration: var(--link-decoration, underline);
    }

    :global(ol) {
      padding-left: 20px;
      margin: 0.5em 0;
    }

    :global(ol li::marker) {
      font-size: 1.1em;
    }

    :global(ul) {
      padding-left: 20px;
      margin: 0.5em 0;
    }

    :global(li) {
      margin: 0.25em 0;
      line-height: 1.35em;
    }
  }

  .subbmit-button {
    --button-border-color: hsl(var(--color-accent));

    background-color: hsl(var(--color-accent));
    color: hsl(var(--color-font-accent));
  }

  .caret {
    width: 24px;
    height: 24px;
    background: hsl(var(--color-accent));
    mask-image: url("../assets/caret.svg");
    mask-position: center;
    mask-repeat: no-repeat;
    mask-size: 24px;
    position: relative;
    left: 45%;
    right: 55%;
    bottom: 20px;

    &.short {
      bottom: 5px;
    }
  }
</style>

<div
  class="description-wrapper vertical-scroll"
  class:short
  bind:this={wrapper}
  on:scroll={calculatePosition}
  style="mask:{caret
    ? `linear-gradient(${
        rotate ? '0deg' : '180deg'
      }, #D9D9D9 63.84%, rgb(217 217 217 / 0%) 91.51%)`
    : ''}">
  <div class="description">
    <SvelteMarkdown source={description} options={{ breaks: true, gfm: true }} />
  </div>
  <slot name="button">
    {#if url}
      <div class="flex justify-end">
        <a href={url} class="subbmit-button px-[16px]" target="_blank">
          <Button primary variant={"mobile"} disabled={false}
            >{label ?? defaultLabel}</Button>
        </a>
      </div>
    {/if}
  </slot>
</div>
<div class="landscape:hidden">
  <!-- svelte-ignore a11y-click-events-have-key-events -->
  <!-- svelte-ignore a11y-no-static-element-interactions -->
  <div
    class="z-10"
    class:caret
    class:rotate-180={rotate}
    class:short
    on:click={clickHandler} />
</div>
